import { FeatureKeys } from '../store/auth-manager';

export const ConfigKeys = {
  RULE_ENGINE_ENABLED: 'ruleEngineEnabled',
  CUSTOM_FIELDS_ENABLED: 'customFieldsEnabled',
  CUSTOM_VALIDATIONS_ENABLED: 'customValidationsEnabled',
  CUSTOM_SENDING_UI_ENABLED: 'customSendingUiEnabled',
  CUSTOM_FIELD_PAGE_ENABLED: 'customFieldPageEnabled',
};

export const TOGGLE_FIELDS = [
  {
    key: ConfigKeys.RULE_ENGINE_ENABLED,
    label: 'WORKFLOW_BUILDER_RULE_ENGINE',
    hint: 'WORKFLOW_BUILDER_RULE_ENGINE_HINT',
    featureId: FeatureKeys.RULE_ENGINE,
  },
  {
    key: ConfigKeys.CUSTOM_FIELDS_ENABLED,
    label: 'WORKFLOW_BUILDER_CUSTOM_FIELDS',
    hint: 'WORKFLOW_BUILDER_CUSTOM_FIELDS_HINT',
    featureId: FeatureKeys.CUSTOM_FIELDS_TOGGLE,
  },
  {
    key: ConfigKeys.CUSTOM_VALIDATIONS_ENABLED,
    label: 'WORKFLOW_BUILDER_CUSTOM_VALIDATIONS',
    hint: 'WORKFLOW_BUILDER_CUSTOM_VALIDATIONS_HINT',
    featureId: FeatureKeys.CUSTOM_VALIDATIONS,
  },
  {
    key: ConfigKeys.CUSTOM_SENDING_UI_ENABLED,
    label: 'WORKFLOW_BUILDER_CUSTOM_SENDING_UI',
    hint: 'WORKFLOW_BUILDER_CUSTOM_SENDING_UI_HINT',
    featureId: FeatureKeys.CUSTOM_SENDING_UI,
  },
  {
    key: ConfigKeys.CUSTOM_FIELD_PAGE_ENABLED,
    label: 'WORKFLOW_BUILDER_CUSTOM_FIELD_PAGE',
    hint: 'WORKFLOW_BUILDER_CUSTOM_FIELD_PAGE_HINT',
    featureId: FeatureKeys.CUSTOM_FIELD_PAGE,
  },
];
